// DashboardFilters.jsx
import React from 'react';
import {
  Grid, TextField, Button, FormControl,
  InputLabel, Select, MenuItem, Paper
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { Refresh as RefreshIcon } from '@mui/icons-material';

const DashboardFilters = ({ filters, onFilterChange }) => {
  const handleDateChange = (date, type) => {
    onFilterChange({
      ...filters,
      dateRange: { ...filters.dateRange, [type]: date }
    });
  };

  const handleTimeRangeChange = (e) => {
    onFilterChange({
      ...filters,
      timeRange: e.target.value
    });
  };

  const handleRefresh = () => {
    // Refresh logic here
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
    <Paper sx={{ p: 2, mb: 3 }}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            placeholder="Search..."
            variant="outlined"
            size="small"
          />
        </Grid>
        <Grid item xs={6} md={2}>
          <DatePicker
            label="Start Date"
            value={filters.dateRange.start}
            onChange={(date) => handleDateChange(date, 'start')}
            renderInput={(params) => <TextField {...params} size="small" fullWidth />}
          />
        </Grid>
        <Grid item xs={6} md={2}>
          <DatePicker
            label="End Date"
            value={filters.dateRange.end}
            onChange={(date) => handleDateChange(date, 'end')}
            renderInput={(params) => <TextField {...params} size="small" fullWidth />}
          />
        </Grid>
        <Grid item xs={6} md={2}>
          <FormControl fullWidth size="small">
            <InputLabel>Time Range</InputLabel>
            <Select
              value={filters.timeRange}
              label="Time Range"
              onChange={handleTimeRangeChange}
            >
              <MenuItem value="day">Daily</MenuItem>
              <MenuItem value="week">Weekly</MenuItem>
              <MenuItem value="month">Monthly</MenuItem>
              <MenuItem value="quarter">Quarterly</MenuItem>
              <MenuItem value="year">Yearly</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={6} md={2}>
          <Button
            variant="outlined"
            startIcon={<RefreshIcon />}
            onClick={handleRefresh}
            fullWidth
          >
            Refresh
          </Button>
        </Grid>
      </Grid>
    </Paper>
    </LocalizationProvider>
  );
};

export default DashboardFilters;